import { Link } from "gatsby";
import * as React from "react";
import { IDestination } from "../../../../@types/IDestination";
import {
  cityImage,
  container,
  imageContainer,
} from "./Destination.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { destinationLink } from "../FeaturedDestinations.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const DestinationLink: React.FC<IDestination> = (props) => {
  if (!props.relationships) {
    return <></>;
  }
  const image = getImage(props.relationships.media.gatsbyImage);
  const city = props ? props.relationships.city : null;
  const handleClick = (_id: string) => {
    //dispatch(setSearch({ distance: 50 }));
  };
  return (
    <>
      {city && image && (
        <Link
          to={city.path.alias}
          title={city.name}
          onClick={() => handleClick(city.path.alias)}
          className={destinationLink}
        >
          <CityImage image={image} city={city.name}></CityImage>
        </Link>
      )}
    </>
  );
};
export const CityImage: React.FC<any> = (props) => {
  return (
    <div className={imageContainer}>
      <GatsbyImage image={props.image} alt={props.city} className={cityImage} />
      <span>{props.city}</span>
    </div>
  );
};
